import { createAction } from 'redux-actions'

import { GET_BLOGS, CREATE_ARTICLE, DELETE_ARTICLE, UPDATE_ARTICLE } from './constants'
import { getBlogsApi, createArticleApi, deleteArticleApi, updateArticleApi } from './api'

export const getBlogsAction = createAction(GET_BLOGS, async (data) => await getBlogsApi(data))
export const createArticleAction = createAction(CREATE_ARTICLE, async (data) => await createArticleApi(data))
export const updateArticleAction = createAction(UPDATE_ARTICLE, async (id, data) => await updateArticleApi(id, data))
export const deleteArticleAction = createAction(DELETE_ARTICLE, async (id) => await deleteArticleApi(id))
